import type { SVGProps } from 'react';

export const DocumentOnDocumentSFSymbolRegular = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.332 24.5996"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="24.5996" opacity="0" width="20.332" x="0" y="0" />{' '}
        <path
          d="M14.0625 0.976562L18.9941 5.98633C19.7266 6.73828 19.9707 7.5 19.9707 8.70117L19.9707 16.6309C19.9707 18.6621 18.9551 19.6973 16.9434 19.6973L15.2344 19.6973L15.2344 18.125L16.8555 18.125C17.8711 18.125 18.3984 17.5781 18.3984 16.6016L18.3984 8.25195L13.8281 8.25195C12.7051 8.25195 12.1582 7.71484 12.1582 6.58203L12.1582 1.57227L7.8418 1.57227C6.82617 1.57227 6.30859 2.12891 6.30859 3.0957L6.30859 4.87305L4.73633 4.87305L4.73633 3.06641C4.73633 1.03516 5.75195 0 7.76367 0L11.5039 0C12.5488 0 13.3691 0.263672 14.0625 0.976562ZM13.5742 6.34766C13.5742 6.68945 13.7109 6.83594 14.0527 6.83594L17.9883 6.83594L13.5742 2.34375Z"
          fill="currentColor"
        />{' '}
        <path
          d="M0 21.5039C0 23.5449 1.00586 24.5703 3.02734 24.5703L12.207 24.5703C14.2285 24.5703 15.2344 23.5352 15.2344 21.5039L15.2344 13.877C15.2344 12.627 15.0879 12.0801 14.3066 11.2793L8.92578 5.80078C8.18359 5.03906 7.56836 4.87305 6.47461 4.87305L3.02734 4.87305C1.01562 4.87305 0 5.89844 0 7.93945ZM1.57227 21.4746L1.57227 7.95898C1.57227 7.00195 2.08984 6.44531 3.10547 6.44531L6.30859 6.44531L6.30859 12.1094C6.30859 13.3398 6.93359 13.9551 8.14453 13.9551L13.6621 13.9551L13.6621 21.4746C13.6621 22.4512 13.1348 22.998 12.1289 22.998L3.0957 22.998C2.08984 22.998 1.57227 22.4512 1.57227 21.4746ZM8.33008 12.4805C7.93945 12.4805 7.7832 12.3242 7.7832 11.9336L7.7832 6.80664L13.3594 12.4805Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
